import React from "react";
import { motion } from "framer-motion";
import { Link2, Rocket, Coffee } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: Link2,
    title: "Connect your broker",
    body: "One-click, encrypted link to your existing trading account. Zerodha, Angel, Upstox, Dhan — we're broker-agnostic.",
  },
  {
    n: "02",
    icon: Rocket,
    title: "Pick or build a strategy",
    body: "Choose a pre-built for bullish/bearish/sideways markets, or build your own with simple tiles. Customize every leg in rupees.",
  },
  {
    n: "03",
    icon: Coffee,
    title: "Go live. Go back to life.",
    body: "Hit deploy. Tradecure handles entries, exits, SL, trailing, and live adjustments. You get a summary when it's done.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      data-testid="how-it-works-section"
      className="py-20 md:py-28 bg-white"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
          className="flex items-end justify-between flex-wrap gap-4"
        >
          <div className="max-w-2xl">
            <div className="font-mono text-xs font-bold text-[#084392] tracking-[0.2em]">
              / HOW IT WORKS
            </div>
            <h2 className="font-heading mt-3 text-4xl md:text-5xl lg:text-6xl font-black tracking-tighter">
              Three clicks.
              <br />
              You&rsquo;re automated.
            </h2>
          </div>
        </motion.div>

        <div className="mt-14 grid md:grid-cols-3 gap-6 md:gap-0 md:divide-x divide-[#e2e8f0] border border-[#e2e8f0] rounded-2xl overflow-hidden">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, delay: i * 0.1 }}
                data-testid={`how-step-${i}`}
                className="relative p-8 md:p-10 group hover:bg-[#f8fafc] transition"
              >
                <div className="flex items-center justify-between">
                  <span className="font-mono text-sm font-bold text-[#084392]">
                    {s.n}
                  </span>
                  <div className="h-12 w-12 rounded-xl bg-[#084392]/10 text-[#084392] flex items-center justify-center group-hover:bg-[#084392] group-hover:text-white transition">
                    <Icon size={20} />
                  </div>
                </div>
                <h3 className="font-heading mt-6 text-2xl md:text-3xl font-bold tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-[#475569] leading-relaxed">{s.body}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
